window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign(
    {},
    window.bundleapp.settings || {},
    {
        bab: {
            productImage: 600
        }
    },
);

(function(){
    function onReady(cb){
        if (document.readyState === 'complete' || document.readyState === 'interactive'){
            cb();
        } else {
            document.addEventListener('DOMContentLoaded', cb);
        }
    }

    onReady(function(){
        var path = 'tools/bundle-subscriptions/bundle/10200573477173';
        if (window.location.href.indexOf(path) === -1) return;

        var selector = '.bundleapp-modal__container--complete-screen .bundle-container';
        var imgId = 'bundle-subscription-placeholder-img';

        var interval = setInterval(function(){
            var container = document.querySelector(selector);
            if (container){
                if (!document.getElementById(imgId)){
                    var imgContainer = document.createElement('div');
                    imgContainer.className = 'bundle-subscription-placeholder-img-container';

                    var img = document.createElement('img');
                    img.src = window.plp_banner_src;
                    img.id = imgId;

                    imgContainer.appendChild(img);

                    container.insertBefore(imgContainer, container.firstChild);

                    // var imgOverlay = document.createElement('div');
                    // imgOverlay.className = 'bundle-subscription-placeholder-img-overlay';
                    // imgContainer.appendChild(imgOverlay);

                    var imgText = document.createElement('div');
                    imgText.className = 'bundle-subscription-placeholder-img-text';
                    imgText.innerHTML = '<h1>Custom Subscription</h1>';
                    imgContainer.appendChild(imgText);

                    // insert HTML block below the image
                    var info = document.createElement('div');
                    info.className = 'bundle-subscription-info';
                    info.innerHTML = '<div class="bs-left"><h3>Build your own wine subscription</h3><p>Craft your own box—filled with the wines you love, delivered on your schedule, and made to savor life\'s most meaningful moments. Subscriptions include the most recently released vintage each year. Vintages update annually as new releases become available.</p></div><aside class="bs-right"><h4>Subscription Details</h4><ul><li>Flexible vintage mix, choose your favorite!</li><li>Set deliveries every 1, 2, or 3 months.</li><li>Your subscription unlocks exclusive access to The Oak Society.</li><li>Wines ship directly from our winery</li></ul></aside>';
                    container.insertBefore(info, imgContainer.nextSibling);
                    
                    // insert HTML block below the image
                    const createContent = document.querySelector('.bundle-create-content');
                    var itemsheader = document.createElement('div');
                    itemsheader.className = 'bundle-subscription-itemsheader';
                    itemsheader.innerHTML = '<div class="main-bab-header"><h3>Build your own wine subscription</h3><p>Craft your own box—filled with the wines you love</p></div>';
                    container.insertBefore(itemsheader, createContent);
                }
                clearInterval(interval);
            }
        }, 50);
    });

    // window.RemoveAwtCartBundle = async (bundle_id) => {
    //   if (!bundle_id) return;

    //   try {
    //     // Get current cart contents
    //     const cart = await (await fetch('/cart.js')).json();
    
    //     // Create data object for cart update AJAX call
    //     const data = {
    //       updates: cart.items.reduce((acc, item) => (
    //         (item.properties?._bundleUid == bundle_id) ? { ...acc, [item.key]: 0 } : acc
    //       ), {})
    //     };
    
    //     // API call to update the cart contents and set the bundle item quantities to 0
    //     const response = await fetch('/cart/update.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify(data)
    //     });
    
    //     response.ok && (window.location.href = '/cart');
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }

})();